<template>
    <div>
        <div class="page d-flex justify-content-between">
            <SideBar :menu="menu"></SideBar>
            <div class="page-wrapper">
                <Navbar></Navbar>
                <div
                    class="page-content"
                    :class="{
                        full: FULL_SCREEN_ROUTE_NAMES.includes($route.name),
                    }"
                >
                    <MaintenanceAlert></MaintenanceAlert>
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div v-if="overlay" class="overlay" @click="closeSideBar"></div>
        </transition>
        <ModalUserBanned></ModalUserBanned>
        <Downloader></Downloader>
        <ModalConfirmEnableTwoFA
            v-model="modalConfirmTwoFA"
            @onConfirm="openModalVerifyTwoFA"
        ></ModalConfirmEnableTwoFA>
        <ModalVerifyTwoFA v-model="modalVerifyTwoFA"></ModalVerifyTwoFA>
    </div>
</template>

<script>
import ModalConfirmEnableTwoFA from '@/components/auth/ModalConfirmEnableTwoFA/ModalConfirmEnableTwoFA';
import ModalVerifyTwoFA from '@/components/auth/ModalVerifyTwoFA/ModalVerifyTwoFA';
import Downloader from '@/components/downloader/Downloader/Downloader';
import Navbar from '@/components/layout/Navbar/Navbar';
import SideBar from '@/components/layout/SideBar/SideBar';
import MaintenanceAlert from '@/components/maintenance/MaintenanceAlert/MaintenanceAlert';
import ModalUserBanned from '@/components/utils/ModalUserBanned/ModalUserBanned';
import { LOGIN_MESSAGE } from '@/constants/auth';
import { FULL_SCREEN_ROUTE_NAMES } from '@/constants/config';
import { SIDEBAR_MENU_ITEMS } from '@/constants/menu';
import AuthStateMixin from '@/mixins/auth-state';
import UserMixin from '@/mixins/user';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: 'Master',
    components: {
        ModalVerifyTwoFA,
        ModalConfirmEnableTwoFA,
        Downloader,
        ModalUserBanned,
        MaintenanceAlert,
        Navbar,
        SideBar,
    },
    mixins: [UserMixin, AuthStateMixin],
    data() {
        return {
            connectedSocket: false,
            onConnectWsEvent: 'connect',
            FULL_SCREEN_ROUTE_NAMES,
            modalConfirmTwoFA: false,
            modalVerifyTwoFA: false,
        };
    },
    computed: {
        ...mapState('nav', ['overlay']),
        ...mapState('auth', ['user', 'accessToken', 'currentLoginMessage']),
        ...mapGetters('auth', ['loggedIn']),
        menu() {
            return SIDEBAR_MENU_ITEMS;
        },
    },
    watch: {
        currentLoginMessage: {
            immediate: true,
            handler(message) {
                if (message === LOGIN_MESSAGE.SUGGEST_ENABLE_2FA) {
                    this.modalConfirmTwoFA = true;
                }
            },
        },
        loggedIn(value) {
            if (!value) {
                this.$store.commit('auth/setCurrentLoginMessage', '');
            }
        },
    },
    mounted() {
        this.fetchMaintenance();
    },
    methods: {
        ...mapActions('maintenance', ['fetchMaintenance']),
        closeSideBar() {
            this.$store.commit('nav/closeSidebar');
        },
        openModalVerifyTwoFA(value) {
            this.modalVerifyTwoFA = value;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'Master';
</style>
